export default "__VITE_ASSET__0$D$9gpQ__"